'use client';

import { SignInDialog } from '@eliadmin/core/src/components/dialog/lazy-dialogs';
import { useDialogStore } from '@eliadmin/core/src/components/ui/dialog';
import { GenericLoader } from '@eliadmin/core/src/components/ui/generic-loader';
import type { EliPageProps } from '@eliadmin/core/src/i18n/i18n-types';
import { useCustomerStore } from '@eliadmin/core/src/stores/customer-store';
import { useEffect, type PropsWithChildren } from 'react';

export default function Layout(props: PropsWithChildren<EliPageProps>) {
  const me = useCustomerStore(s => s.me);
  const isInitialized = useCustomerStore(s => s.isInitialized);
  const openDialog = useDialogStore(s => s.open);

  useEffect(() => {
    if (!me && isInitialized) {
      openDialog({
        id: SignInDialog.id,
        content: <SignInDialog />,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me, isInitialized]);

  if (!me && !isInitialized) {
    return <GenericLoader />;
  }

  if (!me) {
    return null;
  }

  return props.children;
}
